import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=1eb77acf&scoped=true&"
import script from "./DialogWrapper.vue?vue&type=script&lang=ts&"
export * from "./DialogWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=1eb77acf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb77acf",
  null
  
)

export default component.exports